import React from 'react';

function ContactSuccess() {
    return(null);
}

export default ContactSuccess;